export default "__VITE_ASSET__Dpq7FSon__"